
import { LoadingState } from "@/components/admin/LoadingState";

interface LoadingAuthenticationProps {
  message: string;
}

export const LoadingAuthentication = ({ message }: LoadingAuthenticationProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <LoadingState />
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
};
